import React from 'react';
import Modal from 'react-bootstrap/Modal';

import {Button} from 'react-bootstrap'

import './action-panel.styles.scss';

// Modal with header, image, text and 2 buttons with 2 separate actions
const ActionPanel = ({show, onHide, header, icon, mainText, acceptButton, rejectButton}) => {

    return (
        <Modal className="action-panel" show={show} onHide={onHide}>
            {header &&
            <Modal.Header>
                <Modal.Title className='modal-title-1'> {header} </Modal.Title>
                {onHide && <Button className="close-document-viewer-btn btn-primary" onClick={() => onHide()}></Button>}
            </Modal.Header>}

            <Modal.Body className="action-popup">
                {icon &&
                    <div className="modal-icon">
                        <img src={icon} alt={"Modal Icon"}/>
                    </div>
                }

                <div>
                    <h3 className="action-panel-text">
                        {mainText}
                    </h3>

                    <div className="button-row">
                        {acceptButton}
                        {rejectButton}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ActionPanel;